import React from 'react';
import { Box } from '@mui/material';

/**
 * 🏴 COMPOSANT DRAPEAU DE PAYS
 * 
 * Affiche le drapeau d'un pays en utilisant des images au lieu d'emojis
 * pour une meilleure compatibilité entre navigateurs.
 * 
 * Utilise l'API flagcdn.com pour les images de drapeaux.
 */
const CountryFlag = ({ 
  countryCode, 
  countryName = '', 
  size = 'medium',
  style = {},
  showFallback = true,
  ...props 
}) => {
  // Tailles prédéfinies
  const sizes = {
    small: { width: 16, height: 12 },
    medium: { width: 20, height: 15 },
    large: { width: 24, height: 18 },
    xlarge: { width: 32, height: 24 }
  };

  const flagSize = typeof size === 'object' ? size : sizes[size] || sizes.medium;

  // Si pas de code pays, afficher le fallback
  if (!countryCode || countryCode === 'WW') {
    return showFallback ? (
      <span 
        style={{ 
          fontSize: flagSize.width + 'px',
          lineHeight: 1,
          ...style 
        }}
        {...props}
      >
        🌍
      </span>
    ) : null;
  }

  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ...style
      }}
      {...props}
    >
      <img
        src={`https://flagcdn.com/w${flagSize.width * 2}/${countryCode.toLowerCase()}.png`}
        alt={`Drapeau ${countryName || countryCode}`}
        style={{
          width: flagSize.width + 'px',
          height: flagSize.height + 'px',
          borderRadius: '2px',
          objectFit: 'cover',
          display: 'block'
        }}
        onError={(e) => {
          // En cas d'erreur, afficher le fallback emoji
          if (showFallback) {
            e.target.style.display = 'none';
            const fallback = document.createElement('span');
            fallback.textContent = '🌍';
            fallback.style.fontSize = flagSize.width + 'px';
            fallback.style.lineHeight = '1';
            e.target.parentNode.appendChild(fallback);
          }
        }}
        loading="lazy"
      />
    </Box>
  );
};

export default CountryFlag;